import { IModules, INotifiers } from "lib/millennium.core";
import { Client } from "lib/wts.client";

if (!(window as any).millennium) (window as any).millennium = {}

if (!(window as any).millennium.lib) (window as any).millennium.lib = {
    get "wts.ui.controls"() {
      return import("lib/wts.ui.controls")
    },
    get "wts.ui.templating"() {
      return import("lib/wts.ui.templating")
    },
    get "wts.ui.overlays"() {
      return import("lib/wts.ui.overlays")
    },
    get "wts.client"() {
      return import("lib/wts.client")
    }
}

if (!(window as any).millennium.params) (window as any).millennium.params = new Map<string, string>(
    location.search.slice(1).split("&").map(e => {
      const parts = e.split("="); return [parts[0]?.toLocaleLowerCase(), parts[1]]
    }))

export const modules: IModules = {
  "home": {
    instance: () => import("./pages/millennium.home/millennium.home"),
    css: () => import("./pages/millennium.home/millennium.home.scss"),
    html: () => import("./pages/millennium.home/millennium.home.html")
  },
  "dataform": {
    instance: () => import("./pages/millennium.dataform/millennium.dataform"),
    css: () => import("./pages/millennium.dataform/millennium.dataform.scss"),
    html: () => import("./pages/millennium.dataform/millennium.dataform.html")
  },
  "dataview": {
    instance: () => import("./pages/millennium.dataview/millennium.dataview"),
    css: () => import("./pages/millennium.dataview/millennium.dataview.scss"),
    html: () => import("./pages/millennium.dataview/millennium.dataview.html")
  },
  "portal": {
    instance: () => import("./pages/millennium.portal/millennium.portal"),
    css: () => import("./pages/millennium.portal/millennium.portal.scss"),
    html: () => import("./pages/millennium.portal/millennium.portal.html")
  },
  "playground": {
    instance: () => import("./pages/playground/playground"),
    css: () => import("./pages/playground/playground.scss"),
    html: () => import("./pages/playground/playground.html")
  },
  "reports": {
    instance: () => import("./pages/millennium.reports/millennium.reports"),
    css: () => import("./pages/millennium.reports/millennium.reports.scss"),
    html: () => import("./pages/millennium.reports/millennium.reports.html")
  },
  "reports_catalog": {
    instance: () => import("./pages/millennium.reports/millennium.reports.catalog"),
    css: () => import("./pages/millennium.reports/millennium.reports.catalog.scss"),
    html: () => import("./pages/millennium.reports/millennium.reports.catalog.html")
  },
  "configuration": {
    instance: () => import("./pages/millennium.configuration/millennium.configuration"),
    css: () => import("./pages/millennium.configuration/millennium.configuration.scss"),
    html: () => import("./pages/millennium.configuration/millennium.configuration.html")
  },
  "modules": {
    instance: () => import("./pages/millennium.plugins/millennium.plugins"),
    css: () => import("./pages/millennium.plugins/millennium.plugins.scss"),
    html: () => import("./pages/millennium.plugins/millennium.plugins.html")
  },
  "monitor": {
    instance: () => import("./pages/millennium.monitor/millennium.monitor"),
    css: () => import("./pages/millennium.monitor/millennium.monitor.scss"),
    html: () => import("./pages/millennium.monitor/millennium.monitor.html")
  },
  "openbanking": {
    instance: () => import("./pages/millennium.openbanking/millennium.openbanking"),
    css: () => import("./pages/millennium.openbanking/millennium.openbanking.scss"),
    html: () => import("./pages/millennium.openbanking/millennium.openbanking.html")
  },
  "openbankingListaContas": {
    instance: () => import("./pages/millennium.openbanking/millennium.openbanking.Contas"),
    css: () => import("./pages/millennium.openbanking/millennium.openbanking.Contas.scss"),
    html: () => import("./pages/millennium.openbanking/millennium.openbanking.Contas.html")
  },
  "linx_explorer": {
    instance: () => import("./pages/millennium.linx_explorer/millennium.linx_explorer"),
    css: () => import("./pages/millennium.linx_explorer/millennium.linx_explorer.scss"),
    html: () => import("./pages/millennium.linx_explorer/millennium.linx_explorer.html")
  }
};

const es6module = "es6loader.js";
let es6loader: any;

const moduleNames: { name: string }[] = [];
const moduleInstances = new WeakMap<{ name: string }, any>();

function importModule(fileName: string, moduleName?: string) {

  let nameObj = moduleNames.find(e => e.name === fileName)!;

  if (nameObj) {
    const instance = moduleInstances.get(nameObj);
    if (instance) {
      if (typeof instance === "string" || instance instanceof Error)
        throw instance;

      return instance
    };
  } else {
    nameObj = { name: fileName };
    moduleNames.push(nameObj);
  }

  return new Promise<any>((resolve, reject) => {
    (window as any).exports = {};
    const script = document.createElement("script");
    script.src = fileName;
    script.onload = function (e) {
      if (!moduleName) {
        moduleName = fileName.slice(fileName.lastIndexOf("/") + 1);
        moduleName = moduleName.slice(0, moduleName.lastIndexOf("."));
        if (moduleName.endsWith(".min"))
          moduleName = moduleName.slice(0, moduleName.lastIndexOf("."));
      }

      const instance = (moduleName && (window as any)[moduleName]) || (window as any).exports;
      moduleInstances.set(nameObj, instance);
      resolve(instance);
    }
    script.onerror = e => {
      const errorStr = "Erro carregando módulo " + nameObj.name;
      moduleInstances.set(nameObj, errorStr);
      reject(errorStr);
    }
    document.head.append(script);
  })
}

export async function loadExtension(name: string): Promise<any> {
  if (name.endsWith(".mjs")) {
    if (!es6loader) es6loader = (await importModule(es6module));
    return es6loader.importES6Module(name);
  }
  else {
    return importModule(name);
  }
}

export async function loadModule(
  name: string
): Promise<{ moduleClass: any; htmlTemplate: string; cssTemplate: string }> {

  let module = modules[name];

  //dynamic module
  if (!module) {
    const libPos = name.indexOf(".");
    const libName = name.slice(0, libPos);
    name = name.slice(libPos + 1);
    try {
      const moduleLib = await importModule(libName + "/" + libName + ".js", libName);
      module = moduleLib.default[name];
    } catch {
      throw Error("Library " + name + " not found");
    }

    if (!module)
      throw Error("Module " + name + " not found in library " + libName)
  }

  return Promise.all([
    module.instance(),
    module.css(),
    module.html()
  ]).then(all => ({
    moduleClass: (all[0] && all[0].default) || all[0] || "",
    cssTemplate: (all[1] && all[1].default) || all[1] || "",
    htmlTemplate: (all[2] && all[2].default) || all[2] || ""
  }));
}

export async function loadNotifiers(): Promise<INotifiers> {
  const notifiers: any[] = [];
  const json = await Client.getJSON<{ module: string }[]>("./millennium.notifiers.json");
  for (const notifierDef of json) {
    const notifierModule = await loadExtension(notifierDef.module);
    notifiers.push(notifierModule);
  }
  return notifiers;
}
